import React, { Component } from 'react';


// Routes
import Routing from './Routing';
import { Routes,Route } from "react-router-dom";



export default function Main (props){
    console.log(props)
    return (
        <Routing/>
    );
  }
